export const INPUT_LENGTH = {
  code: 50,
  name: 250,
  text: 1000,
  note: 5000,
} as const;

export const INPUT_LENGTH_OVERRIDE = {
  username: 200,
  employeeId: 50,
  clientCode: 250,
} as const;
